import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HomePage from "@/pages/home/page";
import CollectionPage from "@/pages/collection/page";
import ProductPage from "@/pages/product/page";
import StoryPage from "@/pages/story/page";
import VisitPage from "@/pages/visit/page";

// All public pages are bespoke. Legacy aliases (/services, /about, /contact) keep old links working.
// src/flash is no longer routed: every page it defined was already overridden here.
const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/collection", element: <CollectionPage /> },
  { path: "/services", element: <CollectionPage /> },
  { path: "/product/:slug", element: <ProductPage /> },
  { path: "/story", element: <StoryPage /> },
  { path: "/about", element: <StoryPage /> },
  { path: "/visit", element: <VisitPage /> },
  { path: "/contact", element: <VisitPage /> },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;